import DqOm61Inventorypanel from './src/om61inventorypanel'

/* istanbul ignore next */
DqOm61Inventorypanel.install = function (Vue) {
  Vue.component(DqOm61Inventorypanel.name, DqOm61Inventorypanel)
}

export default DqOm61Inventorypanel



// WEBPACK FOOTER //
// ./src/dq-ui/packages/om61inventorypanel/om61inventorypanel.js